import * as React from 'react'
import { ReactElement, useContext, useEffect, useState } from 'react'

import {AppContext} from "../../../Context/AppContext"
import { IUser } from '../UserApp'

import { postier } from "./postier"
import { UserAppPostier } from "../UserApp/Postier"

import "./style.scss"
import { Search } from '../../Search'

export function Create(): ReactElement {

    const { token, setLoading, setErrors, userId } = useContext(AppContext)

    const [fields, setFields] = useState({ code: '', database:'', url: '', username: 'etl', password: 'e3@V0l6y', role: 'admin', port: '5432', usersapp: [userId], name: '', isOptician: false})

    const [userList, setUserList] = useState<IUser[]>([]);
    const [urlList, setUrlList] = useState<string[]>([]);  
    const [filteredList, setFilteredList] = useState<IUser[]>([]);

    useEffect(() => {
        UserAppPostier.getUserList(token, "ConsoleAdminBD", setUserList)
        UserAppPostier.getUrlList(token, setUrlList, setErrors)
    }, [])

    useEffect(() => {
        if (urlList.length > 0) {
            setFields({...fields, url: urlList[0]})
        }
    }, [urlList])

    useEffect(() => {
        setFilteredList(userList);
    }, [userList]);

    const checkClientCode = (code: string) => {
        const behaviour = '(cc...)'
    
        var r = new RegExp('^(' + behaviour + ')$')
    
        return r.test(code)
    }

    const validate = () => {
        for (const key in fields) {
            if (fields[key] === '') {
                setErrors((errors: string[]) => [...errors, `${key} doit être défini`])
                return;
            }
        }

        if (!checkClientCode(fields.code)) {
            setErrors((errors: string[]) => [...errors, "L'application ne gère que les clients avec un code sous le format ccXXX, contactez l'équipe BI pour des demandes autres."])
            return;
        }

        const clientBody = {
            Code: fields.code.toLowerCase(),
            URL: fields.url,
            Database: fields.database,
            Username: fields.username,
            Password: fields.password,
            RoleDB: fields.role,
            Port: parseInt(fields.port),
            usersApp: fields.usersapp,
            Owner: fields.username,
            Name: fields.name.replace(/'/g, "''"),
            IsOptician: fields.isOptician,
            apiId: localStorage.getItem('apiId')
        }

        setLoading(true)
        postier.createClient(token, clientBody, setLoading, setErrors)
    }

    const handleChange = (field: string, e) => {
        const fieldsCopy = {...fields};
        fieldsCopy[field] = field === 'isOptician' ? e.target.checked : e.target.value;
        setFields(fieldsCopy);
    };

    const handleCheck = (e) => {
        const fieldsCopy = { ...fields }
        if (e.target.checked) {
            fieldsCopy.usersapp.push(parseInt(e.target.value))
        } else {
            const usersIds = fieldsCopy.usersapp
            const valueToRemove = parseInt(e.target.value)
            const filteredUsersIds = usersIds.filter(userId => userId !== valueToRemove)
            fieldsCopy.usersapp = filteredUsersIds
        }  
        setFields(fieldsCopy)
    }

    return (
        <div className="form-client">
            <h2>Création client</h2>
            <div className="line"></div>
            <div className="cont">
                <label>Code Client</label>
                <input className="label" onChange={e => handleChange('code', e)} />

                <label>Nom de la base de données</label>
                <input className="label" onChange={e => handleChange('database', e)} />

                <label>Nom du client</label>
                <input className="label" onChange={e => handleChange('name', e)} />

                <label>Adresse serveur</label>
                <select className="label" onChange={e => handleChange('url', e)}>
                    {urlList.map((url, index) => <option key={index} value={url}>{url}</option>)}
                </select>

                <label>Utilisateur base de données</label>
                <input className="label" onChange={e => handleChange('username', e)} defaultValue={fields.username} />
                
                <label>Mot de passe base de données</label>
                <input type="password" className="label" onChange={e => handleChange('password', e)} defaultValue={fields.password} />

                <label>Client opticien</label>
                <input type="checkbox" onChange={e => handleChange('isOptician', e)} />

                <label>Affectation utilisateurs Cliris</label>
                <div className="users">
                    <Search needle={userList} setFilteredList={setFilteredList} searchParam={'Username'} style={{width: '90%'}} />
                    {filteredList.map((user: IUser) => {
                        return <div><input type="checkbox" defaultChecked={(userId === user.ID || fields.usersapp.includes(user.ID))} onChange={handleCheck} value={user.ID} />{user.Username}</div>
                    })}
                </div>
            </div>
            <button onClick={validate} >Enregistrer</button>
        </div>
    )
}
